<template>
  <component :is="tag">
    <b-img
      :src="file.url"
      :alt="file.file.name"
      :title="file.file.name"
      class="avatar-img fit-cover shadow rounded-25"
    ></b-img>
    <button
      @click="$emit('remove', file)"
      class="close-icon"
      aria-label="Remove"
    >
      ×
    </button>
  </component>
</template>

<script>
export default {
  props: {
    file: { type: Object, required: true },
    tag: { type: String, default: "li" }
  }
};
</script>

<style>
.close-icon {
  --size: 20px;
  position: absolute;
  line-height: var(--size);
  height: var(--size);
  border-radius: var(--size);
  box-shadow: 0 0 5px currentColor;
  right: 0.25rem;
  appearance: none;
  border: 0;
  padding: 0;
}

.close-icon {
  width: var(--size);
  font-size: var(--size);
  background: #933;
  color: #fff;
  top: 0.25rem;
  cursor: pointer;
}

.avatar-img {
  width: 100%;
  min-height: 100px;
  height: 150px;
  max-height: 150px;
  margin-bottom: 1rem;
  cursor: pointer;
}

.fit-cover {
  object-fit: cover;
}

.rounded-25 {
  border-radius: 10px;
}
</style>
